import { render, staticRenderFns } from "./TabDirigentes.vue?vue&type=template&id=10ec4b4a"
import script from "./TabDirigentes.vue?vue&type=script&lang=ts"
export * from "./TabDirigentes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports